import { Form } from 'react-bootstrap';
import { CountryDropdown } from 'react-country-region-selector';

const Country = ({
  label,
  name,
  value,
  onChange,
  className,
  labelClassName,
  inputClassName,
  required,
}) => (
  <div className={className}>
    {label && (
    <Form.Label className={labelClassName}>
      {label}{required && <span className="text-primary"> *</span>}
    </Form.Label>
    )}
    <CountryDropdown
      valueType="short"
      value={value}
      onChange={(updatedValue) => { onChange({ name, value: updatedValue }); }}
      classes={inputClassName}
    />
  </div>
);

export default Country;
